import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const NotificationSnackbar = ({
  open,
  handleClose,
  message,
  type = "info", // 'info', 'success', 'warning', 'error', 'confirm'
  onConfirm,
  onCancel,
  confirmText = "Yes",
  cancelText = "No",
  autoHideDuration = 5000,
}) => {
  const isConfirmType = type === "confirm";

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    handleClose();
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    handleClose();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={isConfirmType ? null : autoHideDuration}
      onClose={isConfirmType ? null : handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={isConfirmType ? null : handleClose}
        severity={isConfirmType ? "warning" : type}
        sx={{ width: "100%", minWidth: "300px" }}
        action={
          isConfirmType ? (
            <Box sx={{ display: "flex", gap: 1, ml: 2 }}>
              <Button
                color="inherit"
                size="small"
                onClick={handleCancel}
                variant="outlined"
                sx={{
                  borderColor: "rgba(255, 255, 255, 0.5)",
                  "&:hover": {
                    borderColor: "rgba(255, 255, 255, 0.8)",
                  },
                }}
              >
                {cancelText}
              </Button>
              <Button
                color="inherit"
                size="small"
                onClick={handleConfirm}
                variant="contained"
                sx={{
                  bgcolor: "rgba(255, 255, 255, 0.9)",
                  color: "primary.main",
                  "&:hover": {
                    bgcolor: "rgba(255, 255, 255, 1)",
                  },
                }}
              >
                {confirmText}
              </Button>
            </Box>
          ) : null
        }
      >
        <Typography variant="body2">{message}</Typography>
      </Alert>
    </Snackbar>
  );
};

export default NotificationSnackbar;